import Aces from './Aces.vue';
import Leader from './Leader.vue';
import DownloadLogo from './DownloadLogo.vue';
import MediaSpokesPeople from './MediaSpokesPeople.vue';
import Blog from './Blog.vue';
import Values from './Values.vue';
import IconBullets from './IconBullets.vue';
import Event from './Event.vue';

export default {
  Aces,
  Leader,
  DownloadLogo,
  MediaSpokesPeople,
  Blog,
  Values,
  IconBullets,
  Event,
};
